import { ResumeManagerProvider } from './resume-manager.provider';
import { ResumeManager } from './resume-manager.view';

export function FeatureResumeManager() {
   return (
      <ResumeManagerProvider>
         <ResumeManager />
      </ResumeManagerProvider>
   );
}
